import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
/**
 * The `humanTime` utility converts a date to a localized, human-readable time-
 * ago string.
 */
dayjs.extend(relativeTime);
export default function humanTime(time: dayjs.ConfigType): string {
  let d = dayjs(time);
  const now = dayjs();

  // To prevent showing things like "in a few seconds" due to small offsets
  // between client and server time, we always reset future dates to the
  // current time. This will result in "just now" being shown instead.
  if (d.isAfter(now)) {
    d = now;
  }

  const day = 864e5;
  // const diff = d.diff(dayjs());
  const diff = now.diff(d, 'day');
  const hoursDiff = now.diff(d, 'hour');
  let ago: string;

  // If this date was more than a month ago, we'll show the name of the month
  // in the string. If it wasn't this year, we'll show the year as well.
  // if (diff < -30 * day) {
  //   if (d.year() === dayjs().year()) {
  //     ago = d.format('MMM D');
  //   } else {
  //     ago = d.format('ll');
  //   }
  // } else {
  //   ago = d.fromNow();
  // }
  if (diff > 1 || hoursDiff >= 24) {
    ago = d.format('YYYY-MM-DD HH:mm:ss');
  } else {
    ago = d.fromNow();
  }

  return ago;
}
